import { gql } from '~/techstyle-shared/react-graphql';

import { MEMBERSHIP_STATUS } from './constants';
import { PRICING_DETAILS_FIELDS_FRAGMENT } from './gqlFragments';

// Reference: https://studio.apollographql.com/graph/fashionos/variant/dev/schema/reference/objects/Query?query=productpricing

export const PRICING_QUERY_PRICING_SERVICE_V3 = gql`
  ${PRICING_DETAILS_FIELDS_FRAGMENT}

  query CioBrowseGridPricingService(
    $masterProductIds: [Int]
    $membershipStatus: Int
  ) {
    productPricing(
      masterProductIds: $masterProductIds
      membershipStatus: $membershipStatus
    ) {
      ...PricingDetailsFields
    }
  }
`;

/**
 *
 * Function to fetch Pricing Service data using GraphQL via Apollo client.
 *
 * @param {Object} apolloClient - Apollo client instance
 * @param {Array} masterProductIds - Array of master product IDs
 * @param {boolean} isVip - Flag to indicate if the user is a VIP member
 * @returns {Promise} - Promise that resolves to the pricing data
 */
const getGqlPricingDataPricingServiceV3 = ({
  apolloClient,
  masterProductIds,
  isVip,
}) => {
  const productPricingVariables = {
    masterProductIds: masterProductIds.map((id) => Number(id)),
    membershipStatus: isVip
      ? MEMBERSHIP_STATUS.VIP
      : MEMBERSHIP_STATUS.PROSPECTIVE,
  };

  return apolloClient.query({
    context: {
      clientName: 'supergraph',
      headers: {
        'x-datasource-version': 'pricingServicev3',
      },
    },
    query: PRICING_QUERY_PRICING_SERVICE_V3,
    variables: productPricingVariables,
    errorPolicy: 'all',
  });
};

export default getGqlPricingDataPricingServiceV3;
